import React from 'react'
import PropTypes from 'prop-types'
import CustomField from '../CustomField'

/*
 * Note that the input onFocus is assigned but never used.
 * This is explicitly done since the redux-form onFocus triggers
 * a reload of all the chunks when assigning it on the input tag.
 *
 * Only trigger validation when the field is actually touched. We can
 * decide to change this later. Currently it always sets new fields
 * that are systematically generated to display as if they have errors.
 * Please note that this only applies to the redux-form validations,
 * all errors thrown by the back-end will always shown regardless if
 * the form field is already touched or not.
 */
const FlightPassengerRenderField = ({
  input: { onFocus, value, onChange, onBlur, ...restInput },
  inputClassName,
  isDisabled,
  apiError,
  type = 'text',
  plain = false,
  meta: { touched, error, invalid, submitFailed, dirty },
  placeholder,
}) => {
  return (
    <CustomField
      {...restInput}
      inputClassName={inputClassName}
      value={value}
      type={type}
      onChange={onChange}
      touched={touched}
      invalid={(touched && invalid) || Boolean(apiError)}
      onBlur={onBlur}
      submitFailed={
        submitFailed || Boolean(apiError) || (touched && Boolean(error))
      }
      errorMessage={error || apiError}
      isDisabled={isDisabled}
      dirty={dirty}
      plain={plain}
      inlineError
      placeholder={placeholder}
    />
  )
}

FlightPassengerRenderField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }).isRequired,
  inputClassName: PropTypes.string,
  apiError: PropTypes.string,
  isDisabled: PropTypes.bool,
  type: PropTypes.string,
  plain: PropTypes.bool,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    invalid: PropTypes.bool,
    submitFailed: PropTypes.bool,
    dirty: PropTypes.bool,
  }).isRequired,
  placeholder: PropTypes.string,
}

export default FlightPassengerRenderField
